"use client";
async function f(n) {
  const { type: t, messageId: r, reasons: s = [], apiKey: a, apiUrl: i, userProperties: c } = n, d = `${i}/feedback`, o = {
    type: t,
    messageId: r,
    createdAt: (/* @__PURE__ */ new Date()).toISOString(),
    userProperties: c
  };
  t === "negative" && (o.reasons = s);
  const e = await fetch(d, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${a}`
    },
    body: JSON.stringify(o)
  });
  if (!e.ok) {
    const p = await e.text();
    throw new Error(`Failed to send feedback: ${p}`);
  }
  return e.json();
}
export {
  f as submitFeedback
};
